import { ANNOTATION_INSPECTOR_PREFERRED_HEIGHT_REM } from "./MediaAnnotationStudioConstraint";

/** 늘어난 placeholder 배경을 제외하고 안내·액션 또는 슬롯 도구에 필요한 높이를 계산한다. */
export function measureAnnotationInspectorContent(inspector: HTMLElement): number {
  const px = (value: string) => Number.parseFloat(value) || 0;
  const inspectorMin = px(getComputedStyle(inspector).minHeight);
  const tools = inspector.querySelector<HTMLElement>("[data-annotation-tools-content]");
  if (tools) return Math.max(inspectorMin, tools.getBoundingClientRect().height);
  const placeholder = inspector.querySelector<HTMLElement>(
    "[data-annotation-controls-placeholder]",
  );
  const content = placeholder?.querySelector<HTMLElement>("[data-annotation-placeholder-content]");
  if (placeholder && content) {
    const style = getComputedStyle(placeholder);
    const chrome =
      px(style.paddingTop) +
      px(style.paddingBottom) +
      px(style.borderTopWidth) +
      px(style.borderBottomWidth);
    const contentHeight = content.getBoundingClientRect().height;
    const naturalHeight =
      style.boxSizing === "border-box"
        ? Math.max(px(style.minHeight), contentHeight + chrome)
        : Math.max(px(style.minHeight), contentHeight) + chrome;
    return Math.max(inspectorMin, naturalHeight);
  }
  const rem = px(getComputedStyle(document.documentElement).fontSize) || 16;
  return Math.max(inspectorMin, ANNOTATION_INSPECTOR_PREFERRED_HEIGHT_REM * rem);
}
